import {
  Container,
  Header,
  KeyValuePairs,
  StatusIndicator,
} from "@amzn/awsui-components-console";
import React from "react";

import { UserFromApi } from "@/types/user";
import { formatTimestamp } from "@/utils/utils";

import LastChangedCell from "../../common/LastChangedCell";
import { MessageItem } from "../types";

export interface MessageDetailsSectionProps {
  message: MessageItem;
  sender: UserFromApi;
}

const MessageDetailsSection: React.FC<MessageDetailsSectionProps> = ({
  message,
  sender,
}) => (
  <Container header={<Header>Message Details</Header>}>
    <KeyValuePairs
      columns={4}
      items={[
        {
          label: "Original Sender",
          value: sender.name,
        },
        {
          label: "Created",
          value: formatTimestamp(message.created),
        },
        {
          // Who last edited this entry, above the timestamp, in the field's
          // existing position. Plain text: the value carries no control and
          // nothing focusable.
          //
          // With no last-updated timestamp there is nothing to attribute, so
          // the field falls back to the placeholder alone. Passing an absent
          // timestamp through `formatTimestamp` would render "Invalid Date".
          label: "Last Updated",
          value: (
            <LastChangedCell
              identity={message.lastUpdated ? message.lastChangedBy : null}
              timestamp={message.lastUpdated}
              testId={message.id}
            />
          ),
        },
        {
          label: "Cache Status",
          value: (
            <StatusIndicator type={message.cached ? "success" : "stopped"}>
              {message.cacheStatus}
            </StatusIndicator>
          ),
        },
        {
          label: "Conversation ID",
          value: message.conversationId,
        },
        {
          label: "Cache Type",
          value: message.cacheType,
        },
      ]}
    />
  </Container>
);

export default MessageDetailsSection;
